import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

function Card({ item }) {
  return (
    <Link to={`/categories/${item?.slugPath}`} className="luxury-cat-card">
      {/* Background Image */}
      <div 
        className="cat-card-img" 
        style={{ backgroundImage: `url(${item?.image})` }} 
      />
      <div className="cat-card-overlay" />

      {/* Content */}
      <div>
        <div className="cat-icon-badge">
          <Sparkles size={20} />
        </div>
        <h4 className="cat-name-text">{item.name}</h4>
        {/* Agar count API mein hai to item.count dikhao, varna default */}
        <span className="cat-count-text">
          {item.productCount ? `${item.productCount}+ Products` : "Explore Now"}
        </span>
      </div>
    </Link>
  );
}

export default Card;